export default __webpack_public_path__ + "static/media/Button (1).560cac29.svg";